const server =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_SERVER
    : location.origin;

import { formatToURL } from "./utils/formatToURL";

const menu = {
  computed: {
    schoolPages() {
      return this.$rest("school-pages")
        .list.filter(({ title }) => !!title)
        .map(({ title }) => ({
          text: title,
          to: `/escola/${formatToURL(title)}`,
        }));
    },
    education() {
      return this.$rest("education")
        .list.filter(({ title }) => !!title)
        .map(({ title }) => ({
          text: title,
          to: `/ensino/${formatToURL(title)}`,
        }));
    },
    educational() {
      return this.$rest("educational")
        .list.filter(({ title }) => !!title)
        .map(({ title }) => ({
          text: title,
          to: `/educacional/${formatToURL(title)}`,
        }));
    },
    projects() {
      return this.$rest("projects")
        .list.filter(({ title }) => !!title)
        .map(({ title }) => ({
          text: title,
          to: `/projetos/${formatToURL(title)}`,
        }));
    },
    scholarships() {
      return this.$rest("scholarships")
        .list.filter(({ title }) => !!title)
        .map(({ title }) => ({
          text: title,
          to: `/bolsas/${formatToURL(title)}`,
        }));
    },
    student() {
      return this.$rest("student")
        .list.filter(({ title }) => !!title)
        .map(({ attachments, title, text }) => {
          const item = {
            text: title,
          };

          if (text || attachments.length > 1)
            item.to = `/aluno/${formatToURL(title)}`;
          else item.to = this.server + attachments[0].path;

          return item;
        });
    },
    menu() {
      return [
        {
          text: "Escola",
          dropdown: [
            {
              text: "Equipe Diretiva",
              to: "/escola/equipe-diretiva",
            },
            ...this.schoolPages,
          ],
        },
        {
          text: "Ensino",
          dropdown: this.education,
        },
        {
          text: "Educacional",
          dropdown: this.educational,
        },
        {
          text: "Projetos",
          dropdown: this.projects,
        },
        {
          text: "Bolsas",
          dropdown: this.scholarships,
        },
        {
          text: "Aluno",
          dropdown: this.student,
        },
        {
          text: "Imprensa",
          dropdown: [
            {
              text: "Notícias",
              to: "/noticias",
            },
            {
              text: "Galerias de Fotos",
              to: "/galerias-de-fotos",
            },
          ],
        },
        {
          text: "Contato",
          dropdown: [
            {
              text: "Fale Conosco",
              to: "/fale-conosco",
            },
            {
              text: "Trabalhe Conosco",
              to: "/trabalhe-conosco",
            },
          ],
        },
      ];
    },
  },
  created() {
    this.$rest("school-pages").get();
    this.$rest("education").get();
    this.$rest("educational").get();
    this.$rest("projects").get();
    this.$rest("scholarships").get();
    this.$rest("student").get();
  },
};

export { server, menu };
